import { Alert, Form, Input, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import geradorIdUnico from '../../helpers/geradores';
import { gTagEntrada } from '../../helpers/googleAnalytics';
import { BtnSuccess } from '../../styles/Buttons';
import { Label } from './styles';

export const FormLogin = ({ initiateLogin }) => {
  const [useForm] = Form.useForm();
  const [showAddonBefore, setShowAddonBefore] = useState(false);
  const [addonBefore, setAddonBefore] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const onClickEntrar = async form => {
    const { loginWithColon, login, senha } = form;

    try {
      setLoading(true);
      if (showAddonBefore) {
        await initiateLogin(addonBefore + loginWithColon, senha);
      } else {
        await initiateLogin(login, senha);
      }

      setLoading(false);
      history.push('/painel-embarque');

      const eventId = geradorIdUnico();
      localStorage.setItem('idSessao', eventId);
      gTagEntrada(
        'Login',
        'Interação do usuário',
        'Usuário logou no sistema',
        eventId
      );
    } catch (err) {
      setLoading(false);
      const { error } = err.response?.data || {
        error:
          'Ops, nosso servidor não respondeu. Estamos trabalhando para consertar isso o mais rápido possível',
      };
      message.error(error);
    }
  };

  const checkIfThereIsColon = value => {
    if (value.includes(':')) {
      setShowAddonBefore(true);
      setAddonBefore(value);
    } else {
      setShowAddonBefore(false);
      setAddonBefore('');
    }
  };

  const alteraConteudoAddon = event => {
    if (event.target.value === '' && event.keyCode === 8) {
      useForm.setFieldsValue({ login: addonBefore });
      setShowAddonBefore(false);
    }
  };

  return (
    <Form
      form={useForm}
      onFinish={form => onClickEntrar(form)}
      layout="vertical"
      id="form"
    >
      {showAddonBefore && (
        <>
          <Alert
            message="Você está acessando através de outro usuário"
            type="warning"
            style={{ marginTop: 10, marginBottom: 10 }}
          />
          <Form.Item
            name="loginWithColon"
            className="mb-10"
            label={<Label>Login</Label>}
            onChange={event => alteraConteudoAddon(event)}
            onKeyDown={alteraConteudoAddon}
            required
          >
            <Input
              addonBefore={addonBefore}
              className="mt-5"
              id="loginWithColon"
              autoFocus
            />
          </Form.Item>
        </>
      )}

      {!showAddonBefore && (
        <Form.Item
          name="login"
          className="mb-10"
          label={<Label>Login</Label>}
          rules={[
            { required: true, message: 'Por favor, entre com seu login!' },
          ]}
          onChange={event => checkIfThereIsColon(event.target.value)}
        >
          <Input
            className="mt-5"
            placeholder="ex. joao@tmov.com.br"
            id="login"
            autoFocus
          />
        </Form.Item>
      )}

      <Form.Item
        name="senha"
        className="mb-25"
        label={<Label>Senha</Label>}
        rules={[{ required: true, message: 'Por favor, entre com sua senha!' }]}
      >
        <Input.Password
          className="mt-5"
          type="password"
          placeholder="*****"
          id="senha"
        />
      </Form.Item>

      <Form.Item>
        <BtnSuccess block htmlType="submit" id="entrar" loading={loading}>
          Entrar
        </BtnSuccess>
      </Form.Item>
    </Form>
  );
};

FormLogin.propTypes = {
  initiateLogin: PropTypes.func.isRequired,
};
